import { createStructuredSelector } from 'reselect';
import { userDataSelector } from '@selectors/global';
import {
  ownerLookupModalOpenSelector,
  ownerLookupModalModeSelector,
  ownerLookupModalStateSelector,
  ownerLookupModalDataSelector,
  ownerLookupModalRecordCountSelector,
  fieldsSelector,
} from '../../selectors/owner';
import { preferenceSelector } from '../../selectors/global';

export default createStructuredSelector({
  fields: fieldsSelector,
  modalOpen: ownerLookupModalOpenSelector,
  mode: ownerLookupModalModeSelector,
  state: ownerLookupModalStateSelector,
  data: ownerLookupModalDataSelector,
  recordCount: ownerLookupModalRecordCountSelector,
  preference: preferenceSelector,
  userData: userDataSelector,
});
